import store from './state/store';

const getCurrentDate = () => {
  const environment = store.getState().settingsReducer.environment;
  if (environment === 'DEV' || environment === 'TEST' || environment === 'INT') {
    return new Date(); //Date(); Date('2024-03-19');
  }
  return new Date();
};

export default getCurrentDate;
